import React from "react";
import { Text } from "@certa/blocks/thanos";
import { Select } from "@certa/catalyst/components/Select";
import { useIntl } from "react-intl";
import type { ObjectFilterGroup, SelectOption } from "./types";

type ObjectConditionTypeProps = (
  | {
      groupIndex: number;
      conditionIndex?: never;
    }
  | {
      conditionIndex: number;
      groupIndex?: never;
    }
) & {
  customFilterValue: ObjectFilterGroup;
  onChange: (newType: "all" | "any") => void;
};

const compareTypeOptions: SelectOption[] = [
  { label: "AND", value: "all" },
  { label: "OR", value: "any" }
];

export const ObjectConditionType: React.FC<ObjectConditionTypeProps> = ({
  conditionIndex,
  customFilterValue,
  groupIndex,
  onChange
}) => {
  const intl = useIntl();
  const whereText = intl.formatMessage({
    id: "common.where",
    defaultMessage: "Where"
  });
  const compareTypeText = intl.formatMessage({
    id: "common.compareType",
    defaultMessage: "Compare Type"
  });

  const group = customFilterValue;

  const shouldShowWhere =
    conditionIndex === 0 || (groupIndex === 0 && !group.conditions.length);

  const shouldShowSelectField =
    conditionIndex === 1 ||
    (groupIndex === 0 && group.conditions.length === 1) ||
    (groupIndex === 1 && group.conditions.length === 0);

  const handleChange = (value: string) => {
    onChange(value as "all" | "any");
  };

  if (shouldShowWhere) {
    return <Text className="conditionTypeText">{whereText}</Text>;
  } else if (shouldShowSelectField) {
    return (
      <Select
        menuPortalTarget={document.body}
        label={compareTypeText}
        options={compareTypeOptions}
        width="90px"
        isClearable={false}
        onChange={handleChange}
        value={group.type}
      />
    );
  }

  // Show the compare type as text for other conditions
  const displayValue = group.type === "all" ? "AND" : "OR";
  return <Text className="conditionTypeText">{displayValue}</Text>;
};
